import React from "react";
import Tables from "./Tables";
import {  getMetricsTable } from "../../features/tableData/visualSlice"
import { useSelector } from "react-redux";

export default function ViewMetrics() {
    const metricsTable = useSelector(getMetricsTable);
  
console.log(metricsTable);
  return ( 
    <>
        {metricsTable.tableData !== undefined && <Tables headers={metricsTable.tableData.headers} data={metricsTable.tableData.data}/>}
    </>
  );
}
